const SearchModal = ({ searchResults, handleSelectClient, onClose }) => (
  <div className="win-modal-overlay" onClick={onClose}>
    <div className="win-modal" onClick={e => e.stopPropagation()}>
      <div className="win-modal-header">
        <span>Rechercher un client</span>
        <button className="win-modal-close" onClick={onClose}>{'×'}</button>
      </div>
      <div className="win-modal-content">
        <div className="win-search-results">
          {searchResults.length === 0 ? (
            <p>Aucun client trouvé</p>
          ) : (
            <table className="win-table">
              <thead>
                <tr>
                  <th>No Client</th>
                  <th>Nom</th>
                  <th>Prénom</th>
                  <th>Ville</th>
                </tr>
              </thead>
              <tbody>
                {searchResults.map(client => (
                  <tr key={client.id} onClick={() => handleSelectClient(client)} style={{ cursor: 'pointer' }}>
                    <td>{client.no_client}</td>
                    <td>{client.nom}</td>
                    <td>{client.prenom}</td>
                    <td>{client.ville}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default SearchModal;
